var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');

var NotFound = createReactClass({
  render: function(){
    return (
        <div className="wrapper" id="not-found">
            <Helmet title='Page Not Found' />
            <div className="row">
                <div className="medium-8 medium-offset-2 small-12 column end">
                    <h5 className="text-center margin-bottom-large">
                        <strong>404, page not found</strong>
                    </h5>
                    <h2 className="text-center">
                        <strong>Bummer</strong>, we couldn&#39;t find that page.
                    </h2>
                    <hr />
                    <h5 className="text-center">
                        <a href="/">Return to homepage</a>
                    </h5>
                </div>
            </div>
        </div>
    )
  }
});

module.exports = NotFound;



// WEBPACK FOOTER //
// ./src/common/routes/not-found/components/not-found.jsx